module.exports = __webpack_public_path__ + "static/img/jiXie.16101845.jpg";